import { CSSProperties, ReactNode } from "react";
import { ModalV2 } from "../../core/ui/modal/modal";
export function TaskConfirmDialog({ titleId, onCancel, children, style }: { style?: CSSProperties; titleId: string; onCancel: () => void; children: ReactNode }) {
  return <ModalV2 isOpen onClose={onCancel} titleId={titleId} style={style}>{children}</ModalV2>;
}
